const initTableOfContents = (sectionElement) => {
  const tocContainer = sectionElement.querySelector('.toc-container');
  if (!tocContainer) {
    // TOC is not on this page or not enabled in theme customizer
    return;
  }

  const settingsElement = sectionElement.querySelector('#toc-settings');
  if (!settingsElement) {
    console.error('[TOC] Settings JSON script tag not found.');
    return;
  }
  
  const settings = JSON.parse(settingsElement.textContent);

  if (!settings.enable_toc) {
    return; // Double check, though the container shouldn't be rendered anyway
  }

  const articleContent = sectionElement.querySelector('[data-article-content]');
  if (!articleContent) {
    console.error('[TOC] Article content container with [data-article-content] attribute not found.');
    return;
  }

  const includedHeadings = [];
  if (settings.include_h1) includedHeadings.push('h1');
  if (settings.include_h2) includedHeadings.push('h2');
  if (settings.include_h3) includedHeadings.push('h3');
  if (settings.include_h4) includedHeadings.push('h4');
  if (settings.include_h5) includedHeadings.push('h5');
  if (settings.include_h6) includedHeadings.push('h6');
  
  const selector = includedHeadings.join(', ');
  const headings = articleContent.querySelectorAll(selector);
  const tocListContainer = sectionElement.querySelector('#table-of-contents');

  // Clear previous list if re-initializing
  while (tocListContainer.firstChild) {
    tocListContainer.removeChild(tocListContainer.firstChild);
  }

  if (headings.length === 0) {
    tocContainer.style.display = 'none';
    return;
  }
  
  tocContainer.style.display = ''; // Ensure container is visible if it was hidden before

  // ▼▼▼ 変更箇所 ▼▼▼
  // 常に<ul>を使用し、番号はJavaScriptで制御するため、<ol>の自動ナンバリングを避ける
  const list = document.createElement('ul');
  
  // スタイルを設定
  if (settings.toc_list_style === 'bullet') {
    list.style.listStyleType = 'disc'; // 'bullet' の場合のみ 'disc' を設定
  } else {
    // 'numbered' と 'none' の場合はリストマーカーを非表示にする
    list.style.listStyleType = 'none';
  }
  // ▲▲▲ 変更箇所 ▲▲▲

  // 各見出しレベルのカウンターを初期化
  const counters = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 };

  headings.forEach((heading, index) => {
    const id = `toc-heading-${index}`;
    heading.id = id;

    const listItem = document.createElement('li');
    const link = document.createElement('a');
    
    link.href = `#${id}`;

    // ナンバリングが有効な場合のみ、階層的な番号を生成
    if (settings.toc_list_style === 'numbered') {
      const level = parseInt(heading.tagName.substring(1), 10);

      // 現在のレベルのカウンターをインクリメント
      counters[level]++;

      // 現在のレベルより下位のレベルのカウンターをリセット
      for (let i = level + 1; i <= 6; i++) {
        counters[i] = 0;
      }

      // ナンバリング文字列を生成 (例: "1-1. ")
      const numberStringParts = [];
      let baseLevel = 0;
      // どのレベルから開始するかを見つける
      for (let i = 1; i <= 6; i++) {
        if(counters[i] > 0) {
          baseLevel = i;
          break;
        }
      }

      for (let i = baseLevel; i <= level; i++) {
        if (counters[i] > 0) {
          numberStringParts.push(counters[i]);
        }
      }
      const numberString = numberStringParts.join('-') + '. ';

      link.textContent = numberString + heading.textContent.trim();
    } else {
      // 番号なしリストの場合は、従来通り見出しテキストのみ表示
      link.textContent = heading.textContent.trim();
    }
    
    link.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(link.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });

    if (settings.toc_indent_subheadings) {
      const level = parseInt(heading.tagName.substring(1), 10);
      listItem.classList.add(`indent-${level}`);
    }

    listItem.appendChild(link);
    list.appendChild(listItem);
  });

  // Wrap the list in a container for styling the fade-out effect
  const listContainer = document.createElement('div');
  listContainer.classList.add('toc-list-container');
  listContainer.appendChild(list);
  tocListContainer.appendChild(listContainer);

  // Clear previous button if it exists
  const oldButton = tocContainer.querySelector('.toc-toggle-button');
  if (oldButton) {
      oldButton.remove();
  }

  if (settings.toc_collapsible) {
    const toggleButton = document.createElement('button');
    toggleButton.classList.add('toc-toggle-button');
    tocContainer.appendChild(toggleButton); // Place button at the bottom of the main container

    const allItems = list.querySelectorAll('li');
    // Set initial state based on theme setting
    let isExpanded = !settings.toc_start_collapsed;

    const updateTocView = () => {
      const visibleCount = parseInt(settings.toc_visible_items_count, 10);
      const singleLineHeight = allItems.length > 0 ? allItems[0].offsetHeight + 10 : 28; // 10 is for margin-bottom

      if (allItems.length <= visibleCount) {
        toggleButton.style.display = 'none';
        listContainer.classList.remove('is-collapsed');
        return;
      }

      if (isExpanded) {
        listContainer.classList.remove('is-collapsed');
        listContainer.style.maxHeight = '';
        toggleButton.textContent = settings.toc_button_text_collapse || '一部を表示';
        toggleButton.setAttribute('aria-expanded', 'true');
      } else {
        listContainer.classList.add('is-collapsed');
        listContainer.style.maxHeight = `${visibleCount * singleLineHeight}px`;
        toggleButton.textContent = `${settings.toc_button_text_expand || 'すべて表示'} (${allItems.length}件)`;
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    };

    toggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      isExpanded = !isExpanded;
      updateTocView();
    });
    
    // Run once on init to set the button text correctly
    updateTocView();
  }

  // Handle insertion point
  if (settings.toc_insertion_point === 'before_first_heading' && headings.length > 0) {
    const firstHeading = headings[0];
    const parent = firstHeading.parentNode;
    if (parent) {
      parent.insertBefore(tocContainer, firstHeading);
    }
  }
};

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-section--main-article').forEach(section => {
    initTableOfContents(section);
  });
});

// Theme editor reload
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('shopify-section--main-article')) {
    initTableOfContents(event.target);
  }
});